import { useParams } from 'react-router-dom';

export function useRepoParams() {
    const params = useParams();

    // Check for explicit nested path parameters (deprecated but kept for safety)
    if (params.g1 && params.g2 && params.repo) {
        return {
            ...params,
            owner: `${params.g1}/${params.g2}`,
            repo: params.repo,
        };
    }

    // Default 2-segment path (owner/repo)，子路由 `-/*` 的剩余路径在 params['*']（如 pulls/:id）
    if (params.owner && params.repo) {
        const splat = params['*'];
        const out: Record<string, string | undefined> = {
            ...params,
            owner: params.owner,
            repo: params.repo,
        };
        if (typeof splat === 'string' && splat.startsWith('pulls/')) {
            const segments = splat.split('/');
            if (segments.length >= 2 && segments[1] && segments[1] !== 'new') {
                out.id = segments[1];
            }
        }
        return out;
    }

    // Handle wildcard path (infinite nesting)
    const splat = params['*'];
    if (splat) {
        // Check for content separator /-/
        let repoPath = splat;
        let rest = '';
        const sepIndex = splat.indexOf('/-/');
        if (sepIndex !== -1) {
            repoPath = splat.substring(0, sepIndex);
            rest = splat.substring(sepIndex + 3);
        }

        // Parse owner (namespace) and repo name
        const parts = repoPath.split('/');
        if (parts.length >= 2) {
            const repo = parts.pop();
            const owner = parts.join('/');
            const out: Record<string, string | undefined> = { ...params, owner, repo };
            // Parse id from rest when path is pulls/:id
            if (rest.startsWith('pulls/')) {
                const segments = rest.split('/');
                if (segments.length >= 2) out.id = segments[1];
            }
            return out;
        }
    }

    // Fallback
    return params as { owner?: string; repo?: string; id?: string; [key: string]: string | undefined };
}
